import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import defaultImage from "./slider.jpg";
import ListHeader from "../../molecules/ListHeader/ListHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { getWorkerProgress, getWorkersData, getProjectsData } from "../../services/service";
import CommentBox from "../../components/common/CommentBox";
import { Spin, Pagination, Avatar, DatePicker, Select, Form, Button, Dropdown, Menu } from "antd";
import { IMAGE_BASE_URL } from "../../config/api";
import { DropDown, FilterButton } from "../../assets/icons";
import moment from "moment";
import ProgressCard from "../../components/common/ProgressCard";

const { RangePicker } = DatePicker;

const WorkerProgress = () => {
  const location = useLocation();
  const fromProject = location.state?.fromProject;
  const projectId = location.state?.projectId;
  const projectTitle = location.state?.projectTitle;
  const workerId = location.state?.workerId;

  const [form] = Form.useForm();
  const [progressData, setProgressData] = useState([]);
  const [loader, setLoader] = useState(false);
  console.log('dtaa',progressData)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    limit: 10,
    page: 1,
    project_id: '',
    worker_id: '',
    progress_id: ''
  });

  // Add these states for filter options
  const [projects, setProjects] = useState([]);
  const [workers, setWorkers] = useState([]);
  const workerNameById = workers.reduce((acc, w) => {
    if (w?.id && w?.username) acc[String(w.id)] = w.username;
    return acc;
  }, {});

  // Update state declarations
  const [dateRange, setDateRange] = useState(null);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedWorker, setSelectedWorker] = useState('');
  const [filterVisible, setFilterVisible] = useState(false);

  // Add state for applied filters
  const [appliedFilters, setAppliedFilters] = useState({
    dateRange: null,
    project: '',
    worker: ''
  });

  // Pre-select worker if navigated from worker detail page
  useEffect(() => {
    if (workerId) {
      const workerIdString = String(workerId);
      setSelectedWorker(workerIdString);
      setAppliedFilters(prev => ({
        ...prev,
        worker: workerIdString
      }));
      setFilters(prev => ({
        ...prev,
        worker_id: workerIdString,
        page: 1
      }));
    }
  }, [workerId]);

  useEffect(() => {
    fetchProgress();
  }, [filters]);

  const fetchProgress = async () => {
    setLoader(true);
    // Clear existing progress data
    setProgressData([]); 
    
    try {
      const response = await getWorkerProgress(filters);
      if (response?.data) {
        // Set timeout to ensure state is cleared before setting new data
        setTimeout(() => {
          setProgressData(response.data);
          setPagination({
            current: Number(response.pagination.currentPage),
            pageSize: Number(response.pagination.itemsPerPage),
            total: Number(response.pagination.totalItems)
          });
          setLoader(false);
        }, 0);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };

  const handlePageChange = (page, pageSize) => {
    // Clear data first
    setProgressData([]);
    
    // Scroll to top of the page
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    setFilters(prev => ({
      ...prev,
      page: page,
      limit: pageSize
    }));
  };

  const handleFilterSubmit = (values) => {
    const { dateRange, project_id, worker_id } = values;
    
    let newFilters = { ...filters }; // Start with current filters

    // Update date range if provided
    if (dateRange !== undefined) {
      if (dateRange) {
        newFilters.startDate = dateRange[0]?.format('YYYY-MM-DD');
        newFilters.endDate = dateRange[1]?.format('YYYY-MM-DD');
      } else {
        delete newFilters.startDate;
        delete newFilters.endDate;
      }
    }

    // Update project_id if provided
    if (project_id !== undefined) {
      if (project_id) {
        newFilters.project_id = project_id;
      } else {
        delete newFilters.project_id;
      }
    }

    // Update worker_id if provided
    if (worker_id !== undefined) {
      if (worker_id) {
        newFilters.worker_id = worker_id;
      } else {
        delete newFilters.worker_id;
      }
    }

    // Always reset to first page when filters change
    newFilters.page = 1;

    setFilters(newFilters);
  };

  const handleReset = () => {
    form.resetFields();
    setFilters({
      startDate: '',
      endDate: '',
      limit: 10,
      page: 1,
      project_id: '',
      worker_id: '',
      progress_id: ''
    });
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const renderAttachments = (attachments) => {
    return attachments.map((attachment, index) => {
      const fileUrl = `${IMAGE_BASE_URL}${attachment.url}`;
      
      if (attachment.type.startsWith('image/')) {
        return (
          <div key={attachment.id}>
            <img
              src={fileUrl}
              alt={`Attachment ${index + 1}`}
              className="w-full h-[320px] rounded-[4px] object-cover"
            />
          </div>
        );
      }
      // For non-image files, show a download link
      return (
        <div key={attachment.id} className="p-4 border rounded-md mb-2">
          <a 
            href={fileUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {attachment.original_name}
          </a>
        </div>
      );
    });
  };

  const handleGetWorkers = async () => {
    try {
      // Fetch full list similar to other components (limit first, then page)
      const response = await getWorkersData("", 100, 1, "");
      if (response?.success) {
        setWorkers(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching workers data:", error);
    }
  };

  const handleGetProjects = async () => {
    try {
      const response = await getProjectsData("", 1, 100, "");
      if (response?.success) {
        setProjects(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching projects data:", error);
    }
  };

  useEffect(() => {
    handleGetWorkers();
    handleGetProjects();
  }, []);

  const getActiveFilterCount = () => {
    let count = 0;
    if (appliedFilters.project) count++;
    if (appliedFilters.worker) count++;
    return count;
  };

  const getFilterMenu = () => (
    <Menu>
      <div className="p-4 -mt-2 -ml-3 w-[368px] rounded-[8px] bg-white filter-shadow">
        <div className="flex flex-col gap-3 font-medium text-[14px] text-[#4B5563]">
          {/* Project Select */}
          <div>
            <p className="mb-2">Project</p>
            <Select
              placeholder="Select Project"
              value={selectedProject}
              onChange={(value) => {
                setSelectedProject(value);
              }}
              className="w-full !h-[44px] rounded-[4px] border border-[#E9E9E9]"
              suffixIcon={DropDown}
              allowClear
              style={{ 
                fontSize: '12px',
                fontFamily: 'inherit',
                color: '#4B5563',
                fontWeight:'400'
              }}
              dropdownStyle={{
                fontSize: '12px',
                zIndex: 2000
              }}
              getPopupContainer={() => document.body}
            >
              <Select.Option value="">All Projects</Select.Option>
              {projects.map(project => (
                <Select.Option 
                  key={project.id} 
                  value={String(project.id)}
                  style={{ 
                    fontSize: '12px',
                    fontWeight: '400'
                  }}
                >
                  {project.title}
                </Select.Option>
              ))}
            </Select>
          </div>

          {/* Worker Select */}
          <div>
            <p className="mb-2">Worker</p>
            <Select
              placeholder="Select Worker"
              value={selectedWorker}
              onChange={(value) => {
                setSelectedWorker(value);
              }}
              className="w-full !h-[44px] rounded-[4px] border border-[#E9E9E9]"
              suffixIcon={DropDown}
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children || '')
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              style={{ 
                fontSize: '12px',
                fontFamily: 'inherit',
                color: '#4B5563',
                fontWeight:'400'
              }}
              dropdownStyle={{
                fontSize: '12px',
                zIndex: 2000
              }}
              getPopupContainer={() => document.body}
            >
              <Select.Option value="">All Workers</Select.Option>
              {workers
                .slice()
                .sort((a, b) => (a.username || '').localeCompare(b.username || ''))
                .map(worker => (
                <Select.Option 
                  key={worker.id} 
                  value={String(worker.id)}
                  style={{ 
                    fontSize: '12px',
                    fontWeight: '400'
                  }}
                >
                  {worker.username || worker.name || `Worker ${worker.id}`}
                </Select.Option>
              ))}
            </Select>
          </div>

          {/* Apply Button */}
          <Button
            type="submit"
            onClick={() => {
              // Update applied filters
              setAppliedFilters({
                project: selectedProject,
                worker: selectedWorker
              });

              // Update filters for API
              setFilters(prev => ({
                ...prev,
                project_id: selectedProject || '',
                worker_id: selectedWorker || '',
                page: 1
              }));
              setFilterVisible(false);
            }}
            className="bg-[#F97316] border border-[#F97316] w-full h-[44px] font-medium text-[13px] text-white mt-2"
          >
            Apply
          </Button>
        </div>
      </div>
    </Menu>
  );

  const navigate = useNavigate();
  const handleViewProgress = (id) => {

    
    navigate("/progress-detail", {
      state: { 
        progressId: id
      },
    });
  }

  return (
    <div className="w-full flex flex-col gap-6 pb-12">
      <div className="flex justify-between items-center">
        <ListHeader
          mainHeading={fromProject ? `Progress - ${projectTitle}` : "Worker Progress"}
          placeholder="Search"
          btnShow={false}
          linkBreadCrum="/view-worker"
          linkBreadCrum1={fromProject ? "/view-project" : "/view-worker"}
          blinkBreadCrumText={fromProject ? "Project" : "Worker"}
          blinkBreadCrumText1={fromProject ? "View Project" : "View Worker"}
          blinkBreadCrumText2="Progress"
          searchShow={false}
          showLikeFilter={false}
          DropDown={false}
        />
        <Dropdown
          overlay={getFilterMenu()}
          trigger={["click"]}
          placement="bottomRight"
          visible={filterVisible}
          onVisibleChange={(visible) => setFilterVisible(visible)}
          getPopupContainer={() => document.body}
        >
          <span className="cursor-pointer relative">
            {FilterButton}
            {getActiveFilterCount() > 0 && (
              <span className="absolute -top-2 -right-2 bg-[#F97316] text-white rounded-full w-4 h-4 flex items-center justify-center text-[10px]">
                {getActiveFilterCount()}
              </span>
            )}
          </span>
        </Dropdown>
      </div>

      {loader ? (
        <div className="w-full h-screen flex justify-center items-center">
          <Spin />
        </div>
      ) : progressData?.length > 0 ? (
        <>
          <div className="flex flex-col items-center gap-6 w-full">
            {progressData.map((progress, index) => (
              <div key={progress?.id || index} className="w-[60%]">
                <ProgressCard 
                  progress={progress}
                  workerNameById={workerNameById}
                  onProgressClick={handleViewProgress}
                />
              </div>
            ))}
          </div>
          
          <div className="flex justify-center mt-6">
            <Pagination
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              onChange={handlePageChange}
              showSizeChanger={true}
            />
          </div>
        </>
      ) : (
        <div className="text-center text-gray-600">
          No progress data available.
        </div>
      )}
    </div>
  );
};

export default WorkerProgress;
